import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import TrendingTemplate from 'components/trending/TrendingTemplate';
import TrendingSection from 'components/trending/TrendingSection';
import TrendingBannerCards from 'containers/list/TrendingBannerCards';
import SectionProductCards from 'containers/list/SectionProductCards';
import type { State } from 'store';
import type { SectionData } from 'store/modules/common';
import { CommonActions, EventingActions } from "store/actionCreators";
import TrendingEventCards from "../containers/list/TrendingEventCards";

type Props = {
  sections: ?(SectionData[]),
  shouldCancel: boolean,
};

class Trending extends Component<Props> {
  initialize = () => {
    const { shouldCancel, sections } = this.props;
    if (sections && sections.length > 0) {
      // do not fetch sections data when already exists
      return;
    }
    try {
      if (!shouldCancel) {
        CommonActions.getSections();
      }
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    const { sections } = this.props;
    return (
      <TrendingTemplate>
        <Helmet>
          <title>연구원들은 다 아는 쇼핑몰 | 캐시바이</title>
          <meta
            name="description"
            content="연구제품 전문가들에게 빠른 상담을 통해 궁금한 부분을 해결하세요. 견적서와 발주서가 없이도 제품 구매가 가능해요. 원하는 제품을 쉽게 구매하세요."
          />
          <meta name="og:title" content="연구원들은 다 아는 쇼핑몰 | 캐시바이" />
          <meta name="og:type" content="website" />
          <meta name="og:image" content="https://images.cacheby.com/cacheby.png" />
          <meta
            name="og:description"
            content="연구제품 전문가들에게 빠른 상담을 통해 궁금한 부분을 해결하세요. 견적서와 발주서가 없이도 제품 구매가 가능해요. 원하는 제품을 쉽게 구매하세요."
          />
        </Helmet>
        <TrendingSection color="white">
          <TrendingBannerCards />
        </TrendingSection>
        <TrendingSection color="white">
          <TrendingEventCards />
        </TrendingSection>
        {sections &&
          sections.map(section => {
            return (
              <TrendingSection
                key={section.id}
                title={section.title}
                description={section.description}
                color="white"
                more={`/sections/${section.url_slug}`}
              >
                <SectionProductCards products={section.products.slice(0, section.limit)} />
              </TrendingSection>
            );
        })}
      </TrendingTemplate>
    );
  }
}

export default connect(
  ({ common }: State) => ({
    sections: common.sections.data,
    shouldCancel: common.ssr && !common.router.altered,
  }),
  () => ({}),
)(Trending);



// WEBPACK FOOTER //
// ./src/pages/Trending.js